<template>
    <section>
        <div class="content">
            <div class="card card-default">
                <div class="card-header">
                    <h3 class="card-title">
                        <span>
                            <strong><i class="fa-solid fa-magnifying-glass"></i> {{ $t('labels.search') }}</strong>
                        </span>
                    </h3>
                    <div class="card-tools">
                        <button type="button" class="btn btn-tool" data-card-widget="collapse"
                            v-bind:title="$t('labels.collapse')">
                            <i class="fas fa-minus"></i>
                        </button>
                    </div>
                </div>
                <!-- SEARCH CONTENT INPUT-->
                <div class="card-body">
                    <div class="row mb-2 row-cols-1 row-cols-sm-1 row-cols-md-4 row-cols-lg-4 row-cols-xl-4">
                        <div class="col mb-3">
                            <TheSelect id="" title="Số dòng" :options="pageOptions" :initialValue="pageSize.toString()"
                                @onChange="(v) => onChangePageOptions(v)" />
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Hiển thị trên cổng" :options="category_ENABLED"
                                :initialValue="sValue_ENABLED" :isMultiple="false" :isAllowClear="true"
                                :isRequire="false" @onChange="(v) => onSelectSearchChange(v, 'ENABLED')" />
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Chỉ tiêu thu chi" :options="category_CHITIEUTHUCHINGANSACH"
                                :initialValue="sValue_CHITIEUTHUCHINGANSACH" :isMultiple="false" :isAllowClear="true"
                                :isRequire="false"
                                @onChange="(v) => onSelectSearchChange(v, 'CHITIEUTHUCHINGANSACH')" />
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Kỳ" :options="category_sKY" :initialValue="sValue_KYSEARCH"
                                :isMultiple="false" :isAllowClear="true" :isRequire="false"
                                @onChange="(v) => onSelectSearchChange(v, 'KYSEARCH')" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section>
        <div class="content">
            <div class="card card-primary card-outline">
                <div class="card-header">
                    <h3 class="card-title">
                        <i class="fas fa-tag"></i>&nbsp;
                        <b v-if="sType_List == 1">{{ $t('labels.currentList') }}</b>
                        <b v-if="sType_List == 2">{{ $t('labels.deletedList') }}</b>
                    </h3>
                    <div class="card-tools">
                        <button v-if="sType_List == '2'" type="button" class="btn btn-tool"
                            :title="$t('buttons.swapCurrentList')" @click="changeCurrentTypeSearch()">
                            <i class="far fa-list-alt" style="color: #28a745;"></i>
                        </button>

                        <button v-if="sType_List == '1'" type="button" class="btn btn-tool"
                            :title="$t('buttons.swapDeletedList')" @click="changeCurrentTypeSearch()">
                            <i class="fas fa-list-alt" style="color: #df132e;"></i>
                        </button>
                        <button type="button" class="btn btn-tool" data-toggle="dropdown"
                            v-bind:title="$t('buttons.cogs')">
                            <i class="fas fa-cogs"></i>
                            <div class="input-group-prepend">
                                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                                    <a v-if="sType_List == '2'" class="dropdown-item text-green" href="#"
                                        @click="confirmList(navigateCode.RESTORE)" :title="$t('buttons.restore')"><i
                                            class="fas fa-undo"></i>&nbsp;&nbsp;{{ $t('buttons.restore') }}</a>
                                    <div class="dropdown-divider"></div>
                                    <a v-if="sType_List == '1'" class="dropdown-item text-red" href="#"
                                        @click="confirmList(navigateCode.DELETE_TEMP)" :title="$t('buttons.delete')"><i
                                            class="fas fa-trash-restore-alt"></i>&nbsp;&nbsp;{{ $t('buttons.delete')
                                        }}</a>
                                    <a v-if="sType_List == '2'" class="dropdown-item text-red" href="#"
                                        @click="confirmList(navigateCode.DELETE)" :title="$t('buttons.deleteReal')"><i
                                            class="fas fa-trash-restore-alt"></i>&nbsp;&nbsp;{{ $t('buttons.deleteReal')
                                        }}</a>
                                    <div class="dropdown-divider"></div>
                                    <a v-if="sType_List == '1'" class="dropdown-item text-green" href="#"
                                        @click="confirmList(navigateCode.ON_ENABLED)"
                                        :title="$t('buttons.onEnabled')"><i class="fas fa-toggle-on"></i>&nbsp;&nbsp;
                                        {{ $t('buttons.onEnabled') }}</a>
                                    <a v-if="sType_List == '1'" class="dropdown-item text-red" href="#"
                                        @click="confirmList(navigateCode.OFF_ENABLED)"
                                        :title="$t('buttons.offEnabled')"><i class="fas fa-toggle-off"></i>&nbsp;&nbsp;
                                        {{ $t('buttons.offEnabled') }}</a>
                                </div>
                            </div>
                        </button>
                        <button type="button" class="btn btn-tool" @click="detail(null, navigateCode.CREATE)"
                            v-bind:title="$t('buttons.create')">
                            <i class="fas fa-plus"></i>
                        </button>
                        <!-- <button type="button" class="btn btn-tool" @click="getData" v-bind:title="$t('labels.reload')">
                    </button> -->
                        <!-- <button type="button" class="btn btn-tool" data-card-widget="collapse"
                        v-bind:title="$t('labels.collapse')">
                        <i class="fas fa-minus"></i>
                    </button> -->
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive p-0">
                        <loading :active="isBusy" class="text-center" color="#000000" loader="spinner"></loading>
                        <table class="table table-hover table-head-fixed" id="table">
                            <thead>
                                <tr>
                                    <th class="col10">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input" type="checkbox" id="checkboxAll"
                                                @click="selectAllRows($event)">
                                            <label for="checkboxAll" class="custom-control-label"></label>
                                        </div>
                                    </th>
                                    <th class="col10 cursor" @click="handleSortChange('thuchiNgansachId')">
                                        ID
                                        <span v-if="sortBy == 'thuchiNgansachId'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col50 cursor" @click="handleSortChange('tenChitieuThuchiNgansach')">
                                        Chỉ tiêu thu chi
                                        <span v-if="sortBy == 'tenChitieuThuchiNgansach'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col50 cursor" @click="handleSortChange('idKy')">
                                        Kỳ
                                        <span v-if="sortBy == 'idKy'" aria-hidden="true" class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col50">Lũy kế thực hiện</th>
                                    <th class="col50">So với kế hoạch</th>
                                    <th class="col50">Hiển thị trên cổng</th>
                                    <th class="col50"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in items" :key="item._id">
                                    <td @click="selectRow(item.thuchiNgansachId)" style="cursor: pointer;"
                                        :title="$t('labels.selectItem')">
                                        <span v-if="(csList_Navigate.csList.includes(item.thuchiNgansachId))"
                                            aria-hidden="true" class="text-primary">&check;</span>
                                        <span v-else aria-hidden="true">&nbsp;</span>
                                    </td>
                                    <td>{{ item.thuchiNgansachId }}</td>
                                    <td>{{ item.tenChitieuThuchiNgansach }}</td>
                                    <td>{{ item.tenKy }}</td>
                                    <td>{{ item.luyKeThucHien }}</td>
                                    <td>{{ item.soVoiKeHoach }}</td>
                                    <td>
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input"
                                                :disabled="sType_List == 2" :id="'item' + item.thuchiNgansachId"
                                                v-model="item.enabledDisplay"
                                                v-on:click="openConfirmEnabledChange(item)">
                                            <label class="custom-control-label"
                                                :for="'item' + item.thuchiNgansachId"></label>
                                        </div>
                                    </td>
                                    <td>
                                        <button type="button" size="sm" class="btn btn-outline-primary btn-xs"
                                            v-on:click="detail(item, navigateCode.DETAIL)" :title="$t('labels.detail')">
                                            <i class="fas fa-eye text-secondary"></i>
                                        </button>&nbsp;
                                        <span v-if="sType_List == 1">
                                            <button type="button" size="sm" class="btn btn-outline-primary btn-xs"
                                                v-on:click="detail(item, navigateCode.UPDATE)"
                                                :title="$t('labels.update')">
                                                <i class="fas fa-pencil-alt"></i>
                                            </button>&nbsp;
                                        </span>
                                        <button type="button" size="sm" class="btn btn-outline-danger btn-xs"
                                            v-on:click="detail(item, sType_List == 2 ? navigateCode.DELETE : navigateCode.DELETE_TEMP)"
                                            :title="$t('labels.delete')">
                                            <i class="fas fa-trash-alt"></i>
                                        </button>&nbsp;

                                        <button v-if="sType_List == 2" type="button" size="sm"
                                            class="btn btn-outline-warning btn-xs"
                                            v-on:click="detail(item, navigateCode.RESTORE)"
                                            :title="$t('labels.restore')">
                                            <i class="fas fa-undo"></i>
                                        </button>&nbsp;

                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="card-footer clearfix">
                    <div class="row">
                        <div class="col-md-6">
                            <div v-if="totalRow != 0">Hiển thị {{ numberOfShow }} trên tổng số {{ totalRow }} dòng
                            </div>
                            <div v-else> {{ $t('labels.noData') }} </div>
                        </div>
                        <div class="col-md-6">
                            <div class="float-right">
                                <ul class="pagination pagination-rounded">
                                    <paginate :page-count="pageCount" v-model="pageNumber" :page-range="3"
                                        :margin-pages="2" style="cursor: pointer;" :click-handler="handlePageChange"
                                        :prev-text="$t('buttons.previousPage')" :next-text="$t('buttons.nextPage')"
                                        :container-class="'pagination'" :page-class="'page-item'">
                                    </paginate>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <div class="modal fade" id="insUpdModal" data-keyboard="false" data-backdrop="static">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title text-primary">{{ title }}</h4>
                    <button type="button" class="close" aria-label="Close" @click="hideModal()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <TheSelect title="Chỉ tiêu thu chi ngân sách" :options="category_CHITIEUTHUCHINGANSACH"
                                :initialValue="model.chitieuThuchiNgansachId" :error="errors.chitieuThuchiNgansachId"
                                :isMultiple="false" :isReadOnly="isReadOnly" :isAllowClear="true" :isRequire="true"
                                @onChange="(e) => { model.chitieuThuchiNgansachId = e }" :key="tempKey" />
                        </div>

                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <TheSelect title="Kỳ" :options="category_cKY" :initialValue="model.idKy"
                                :error="errors.idKy" :isMultiple="false" :isReadOnly="isReadOnly" :isAllowClear="true"
                                :isRequire="true" @onChange="(e) => { model.idKy = e }" :key="tempKey" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <TheInputText title="Lũy kế thực hiện" placeholder="Nhập lũy kế thực hiện"
                                :initialValue="model.luyKeThucHien" v-model="model.luyKeThucHien"
                                :error="errors.luyKeThucHien" :isReadOnly="isReadOnly" :isRequire=true
                                :isMultipleLine="false" :key="tempKey" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <TheInputText title="So với kế hoạch" placeholder="Nhập so với kế hoạch"
                                :initialValue="model.soVoiKeHoach" v-model="model.soVoiKeHoach"
                                :error="errors.soVoiKeHoach" :isReadOnly="isReadOnly" :isRequire=true
                                :isMultipleLine="false" :key="tempKey" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <TheInputText title="Ghi chú" placeholder="Nhập ghi chú" :initialValue="model.ghiChu"
                                v-model="model.ghiChu" :error="errors.ghiChu" :isReadOnly="isReadOnly" :isRequire=false
                                :isMultipleLine="true" :key="tempKey" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <label>Hiển thị trên cổng</label>
                        </div>
                        <div class="col-md-12">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="enabled-checkbox"
                                    :disabled="isReadOnly" v-model="model.enabledDisplay">
                                <label class="custom-control-label" for="enabled-checkbox"></label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-outline-dark pull-left" @click="hideModal()">&nbsp;{{
                        $t('buttons.close') }} </button>

                    <button type="button" class="pull-right" :class="styleButton" @click="onSubmit();">&nbsp;{{ title
                        }}</button>
                </div>
            </div>

        </div>
    </div>

    <div class="modal fade" id="detailModal" data-keyboard="false" data-backdrop="static">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title text-success">{{ $t('labels.itemDetails') }} </h4>
                    <button type="button" class="close" aria-label="Close" @click="hidePopupDetail">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row" v-if="modelRec">
                        <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                            <p class="text-sm">ID:
                                <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.thuchiNgansachId }}&nbsp;</b>
                            </p>
                            <p class="text-sm">Chỉ tiêu thu chi ngân sách:
                                <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenChitieuThuchiNgansach }}&nbsp;</b>
                            </p>
                            <p class="text-sm">Kỳ:
                                <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenKy }}&nbsp;</b>
                            </p>
                            <p class="text-sm">Lũy kế thực hiện:
                                <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.luyKeThucHien }}&nbsp;</b>
                            </p>
                            <p class="text-sm">So với kế hoạch:
                                <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.soVoiKeHoach }}&nbsp;</b>
                            </p>
                            <p class="text-sm">Ghi chú:
                                <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.ghiChu }}&nbsp;</b>
                            </p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="modal fade" id="confirmcsListModal" data-keyboard="false" data-backdrop="static">
        <TheConfirmDialog :title="csList_MapModel.title" :confirmLabelButton="csList_MapModel.confirmLabelButton"
            :onClose="csList_MapModel.onClose" :onSubmit="csList_MapModel.onSubmit"
            :modalContent=csList_MapModel.modalContent></TheConfirmDialog>
    </div>

    <div class="modal fade" id="enabledConfirmModal" data-keyboard="false" data-backdrop="static">
        <TheCheckboxConfirmDialog :title="csListEnabled_MapModel.title"
            :confirmLabelButton="csListEnabled_MapModel.confirmLabelButton" :onClose="csListEnabled_MapModel.onClose"
            :onSubmit="csListEnabled_MapModel.onSubmit" :modalContent=csListEnabled_MapModel.modalContent
            v-model="checkEnable_Memo" :key="tempKey" :submitArgs="csListEnabled_MapModel.submitArgs">
        </TheCheckboxConfirmDialog>
    </div>


</template>
<script>
import $ from 'jquery'
import { mapActions } from 'vuex'
import config from '@/config/prod.env';
import objectDefaultValue from '@/config/object.env'
import tableValue from '@/config/table.env'
import Paginate from "vuejs-paginate-next";
import Loading from "vue3-loading-overlay";
import { common } from '@/helper/common';
import TheInputText from '@/components/shareComponents/TheInputText.vue';
import TheSelect from '@/components/shareComponents/TheSelect.vue';

import { thuchiNgansachModel } from '@/models/taichinhkehoach/thuchiNgansach.model'
import { tableInteractiveModel } from '@/models/general/tableInteractive.model'

import TheConfirmDialog from '@/components/shareComponents/TheConfirmDialog.vue'
import TheCheckboxConfirmDialog from '@/components/shareComponents/TheCheckboxConfirmDialog.vue'

export default {
    name: "TheThuChiNganSach",
    components: {
        paginate: Paginate,
        loading: Loading,
        TheInputText,
        TheSelect,
        TheConfirmDialog,
        TheCheckboxConfirmDialog,
    },
    data() {
        return {
            header: '',
            isBusy: false,
            filter: null,
            items: [],

            pageNumber: config.CURRENT_PAGE,
            pageSize: config.DEFAULT_LIMIT,
            pageOptions: config.PAGE_OPTION,

            navigateCode: objectDefaultValue.NAVIGATECODE_VALUE,
            navigateList: objectDefaultValue.NAVIGATECODE_LIST,

            totalRow: 0,
            pageCount: 0,
            sortBy: null,
            orderDesc: true,
            numberOfShow: 0,
            title: null,
            code: null,
            styleButton: null,
            styleTitle: null,
            isReadOnly: null,

            modelRec: thuchiNgansachModel.newModel(),
            model: thuchiNgansachModel.newFEModel(),
            errors: thuchiNgansachModel.errors(),

            sValue_ID: null,
            sValue_CHITIEUTHUCHINGANSACH: null,
            sValue_KYSEARCH: null,
            sValue_SORT: null,
            sValue_ENABLED: null,


            csList_Navigate: tableInteractiveModel.newList_NavigateModel(),
            csList_MapModel: tableInteractiveModel.newListEnabled_MapModel(),
            checkEnable_Memo: false,
            sType_List: 1,


            csListEnabled_MapModel: tableInteractiveModel.newListEnabled_MapModel(),
            category_ENABLED: objectDefaultValue.ENABLED_SELECTION,

            category_CHITIEUTHUCHINGANSACH: [],
            category_cKY: [],
            category_sKY: [],

            tempKey: common.randomString(10)
        }
    },
    methods: {
        ...mapActions('header', ['setupHeader',]),
        ...mapActions('alert', ['warning',]),
        ...mapActions('validate', ['validateRequired', 'validateNumber', 'validateFloat'],),
        ...mapActions('thuchiNgansach', ['getPagingThuchiNgansach', 'getDetailThuchiNgansach', 'checkExistThuchiNgansach', 'createThuchiNgansach', 'updateThuchiNgansach', 'deleteThuchiNgansach', 'restoreThuchiNgansach', 'handleListThuchiNgansach', 'setEnabledThuchiNgansach']),
        ...mapActions('dmKy', ['getBasicDMKy', 'getBasicDMKyHienTai']),
        ...mapActions('chitieuThuchiNgansach', ['getBasicChitieuThuchiNgansach']),
        async setup() {
            let header = 'Danh sách thu chi ngân sách'
            this.setupHeader({ header })
        },

        async initialize() {
            this.category_CHITIEUTHUCHINGANSACH = await this.getCategory_ChiTieuThuChiNganSach()
        },

        async showModal() {
            $('#insUpdModal').modal('show')

        },
        async hideModal() {
            $('#insUpdModal').modal('hide')
        },

        async showPopupDetail() {
            $('#detailModal').modal('show')
        },
        async hidePopupDetail() {
            $('#detailModal').modal('hide')
        },

        async showPopupconfirmcsListModal() {
            $('#confirmcsListModal').modal('show')
        },
        async hidePopupconfirmcsListModal() {
            $('#confirmcsListModal').modal('hide')
        },

        async showEnabledConfirmModal() {
            this.csListEnabled_MapModel = {
                title: "XÁC NHẬN",
                confirmLabelButton: "Xác nhận",
                onClose: this.closeConfirmEnabledChange,
                onSubmit: this.updateEnabled,
                submitArgs: [2],
                modalContent: "<label>Bạn có chắc chắn muốn thay đổi hiển thị trên cổng?</label>",
            }
            this.tempKey = common.randomString(10)
            $('#enabledConfirmModal').modal('show')
        },
        async hideEnabledConfirmModal() {
            $('#enabledConfirmModal').modal('hide')
        },

        async handleSortChange(sortCol) {
            if (this.sortBy == sortCol) {
                if (this.orderDesc == true) {
                    this.sortBy = sortCol
                    this.orderDesc = false
                    this.sValue_SORT = sortCol + (this.orderDesc == true ? " desc" : " asc")
                }
                else if (this.orderDesc == false) {
                    this.orderDesc = null
                    this.sortBy = null
                }
            }
            else {
                this.sortBy = sortCol
                this.orderDesc = true
                this.sValue_SORT = sortCol + (this.orderDesc == true ? " desc" : " asc")
            }
            await this.getData()
        },
        async handlePageChange(page) {
            this.pageNumber = page
            await this.getData()
            await this.navigateCheckBoxAll()
        },
        async onChangePageOptions(pageSize) {
            this.pageSize = pageSize
            await this.handlePageChange(1)
        },

        async changeCurrentTypeSearch() {
            if (this.sType_List == 2) this.sType_List = 1
            else if (this.sType_List == 1) this.sType_List = 2
            await this.handlePageChange(1)
        },

        async selectRow(id) {
            if (this.csList_Navigate.csList.includes(id)) {
                this.csList_Navigate.csList.splice(this.csList_Navigate.csList.indexOf(id), 1)
            }
            else {
                this.csList_Navigate.csList.push(id)
            }
            await this.navigateCheckBoxAll()
        },
        async selectAllRows(e) {
            if (e.target.checked) {
                this.csList_Navigate.csList = this.items.map((item) => {
                    return item.thuchiNgansachId
                })
            }
            else {
                this.csList_Navigate.csList = []
            }
        },

        async navigateCheckBoxAll() {
            if (this.items.length != 0 && this.items.length == this.csList_Navigate.csList.length) {
                document.getElementById("checkboxAll").checked = true;
            }
            else {
                document.getElementById("checkboxAll").checked = false;
            }
        },

        async openConfirmEnabledChange(item) {
            if (!this.checkEnable_Memo) {
                this.cEnable_Value = item
                await this.showEnabledConfirmModal()
            }
            else {
                this.cEnable_Value = item
                this.updateEnabled(1)

            }
        },

        async updateEnabled(from) {
            let model = {
                thuchiNgansachId: this.cEnable_Value.thuchiNgansachId,
                enabled: from == 1 ? !this.cEnable_Value.enabledDisplay : this.cEnable_Value.enabledDisplay
            }
            await this.setEnabledThuchiNgansach({ model: model }).then(resp => {
                if (resp) {
                    this.hideEnabledConfirmModal()
                }
                else {
                    this.hideEnabledConfirmModal()
                }
            });
        },

        async closeConfirmEnabledChange() {
            this.cEnable_Value.enabledDisplay = !this.cEnable_Value.enabledDisplay
            $('#item' + this.cEnable_Value.thuchiNgansachId).prop('checked', this.cEnable_Value.enabledDisplay);
            await this.hideEnabledConfirmModal()
        },


        async onSelectSearchChange(e, typeChange) {
            if (typeChange == 'ENABLED') {
                switch (e) {
                    case "true":
                        this.sValue_ENABLED = true
                        break
                    case "false":
                        this.sValue_ENABLED = false
                        break
                    default:
                        this.sValue_ENABLED = null
                }
                this.handlePageChange(1)
                return
            }
            if (typeChange == 'IOCENABLED') {
                switch (e) {
                    case "true":
                        this.sValue_IOCENABLED = true
                        break
                    case "false":
                        this.sValue_IOCENABLED = false
                        break
                    default:
                        this.sValue_IOCENABLED = null
                }
                this.handlePageChange(1)
                return
            }
            if (typeChange == 'CHITIEUTHUCHINGANSACH') {
                this.sValue_CHITIEUTHUCHINGANSACH = e == "" ? null : e
                this.handlePageChange(1)
                return
            }
            if (typeChange == 'KYSEARCH') {
                this.sValue_KYSEARCH = e == "" ? null : e
                this.handlePageChange(1)
                return
            }

        },
        async getData() {
            this.isBusy = true
            this.csList_Navigate.csList = []
            this.category_sKY = await this.getCategory_Ky(1)
            let params = {
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
                chitieuThuchiNgansachId: this.sValue_CHITIEUTHUCHINGANSACH,
                idKy: this.sValue_KYSEARCH,
                sort: this.sValue_SORT,
                enabled: this.sValue_ENABLED,
            }
            await this.getPagingThuchiNgansach({ params: params, type: this.sType_List }).then(res => {
                // List data
                this.items = res.data
                if (this.items) {
                    for (let i = 0; i < this.items.length; i++) {
                        this.items[i].enabledDisplay = this.items[i].enabled == 1 ? true : false
                    }
                }

                // // Total row
                this.totalRow = res.totalRow
                // // Number show
                this.numberOfShow = !this.items ? 0 : ((this.pageNumber - 1) * this.pageSize) + this.items.length;
                // // Total number page
                this.pageCount = parseInt(((this.totalRow - 1) / this.pageSize)) + 1;
            });
            this.isBusy = false;
        },

        async detail(item, code) {
            this.code = code
            this.title = this.$t('labels.' + code)
            this.styleButton = this.$t('style.styleButton' + code)
            this.styleTitle = this.$t('style.styleTitle' + code)
            this.category_cKY = await this.getCategory_Ky()
            this.errors = thuchiNgansachModel.errors()

            if (this.code == this.navigateCode.UPDATE || this.code == this.navigateCode.DELETE || this.code == this.navigateCode.RESTORE || this.code == this.navigateCode.DELETE_TEMP) {
                let params = {
                    thuchiNgansachId: item.thuchiNgansachId
                }
                await this.getDetailThuchiNgansach({ params }).then(async resp => {
                    if (resp) {
                        this.modelRec = thuchiNgansachModel.newModel()
                        this.modelRec = resp
                        this.model = thuchiNgansachModel.parseModeltoFEModel(this.modelRec)
                        let check = this.category_cKY.some(item => item.id == this.model.idKy.toString())
                        if(!check) 
                        this.model.idKy = this.category_cKY[0].id.toString()
                    }
                });
                this.isReadOnly = (this.code == this.navigateCode.DELETE || this.code == this.navigateCode.RESTORE || this.code == this.navigateCode.DELETE_TEMP) ? true : false
                this.tempKey = common.randomString(10)
                await this.showModal()

            }
            else if (this.code == this.navigateCode.DETAIL) {
                let params = {
                    thuchiNgansachId: item.thuchiNgansachId
                }
                await this.getDetailThuchiNgansach({ params }).then(resp => {
                    if (resp == null) {
                        return
                    }
                    else {
                        this.modelRec = thuchiNgansachModel.newModel()
                        this.modelRec = resp
                    }
                });
                this.tempKey = common.randomString(10)
                this.showPopupDetail()
            }
            else {
                this.model = thuchiNgansachModel.newFEModel()
                if(this.category_cKY.length > 0) this.model.idKy = this.category_cKY[0].id.toString()
                this.filesUpload = []
                // show popup
                this.isReadOnly = false
                this.tempKey = common.randomString(10)
                this.showModal()
            }
        },

        async validate(model) {
            let isvalid = true
            this.errors = thuchiNgansachModel.errors()

            if (!await this.validateRequired(model.chitieuThuchiNgansachId)) {
                this.errors.chitieuThuchiNgansachId = "Chọn Chỉ tiêu thu chi ngân sách"
                isvalid = false
            }

            if (!await this.validateRequired(model.idKy)) {
                this.errors.idKy = "Chọn kỳ"
                isvalid = false
            }

            if (!await this.validateRequired(model.luyKeThucHien)) {
                this.errors.luyKeThucHien = "Nhập lũy kế thực hiện"
                isvalid = false
            }
            else if (!await this.validateFloat(model.luyKeThucHien)) {
                this.errors.luyKeThucHien = "Lũy kế thực hiện phải là kiểu số"
                isvalid = false
            }

            if (!await this.validateRequired(model.soVoiKeHoach)) {
                this.errors.soVoiKeHoach = "Nhập so với kế hoạch"
                isvalid = false
            }
            else if (!await this.validateFloat(model.soVoiKeHoach)) {
                this.errors.soVoiKeHoach = "So với kế hoạch phải là kiểu số"
                isvalid = false
            }


            return isvalid
        },
        async modifySendModel(FEmodel) {
            let sendModel = thuchiNgansachModel.newModel()
            if (this.code == this.navigateCode.DELETE
                || this.code == this.navigateCode.RESTORE
                || this.code == this.navigateCode.DELETE_TEMP) sendModel.thuchiNgansachId = FEmodel.thuchiNgansachId
            else {
                if (this.code == this.navigateCode.UPDATE) sendModel.thuchiNgansachId = FEmodel.thuchiNgansachId
                sendModel.chitieuThuchiNgansachId = FEmodel.chitieuThuchiNgansachId
                sendModel.luyKeThucHien = FEmodel.luyKeThucHien
                sendModel.soVoiKeHoach = FEmodel.soVoiKeHoach
                sendModel.idKy = FEmodel.idKy
                sendModel.ghiChu = FEmodel.ghiChu
                sendModel.enabled = FEmodel.enabledDisplay ? FEmodel.enabledDisplay : false
            }

            return sendModel
        },
        async onSubmit() {
            let code = this.code
            let sendModel = await this.modifySendModel(this.model)
            let res = false
            switch (code) {
                case this.navigateCode.CREATE:
                    if (await this.validate(sendModel)) {
                        res = await this.createThuchiNgansach({ model: sendModel })
                    }
                    break
                case this.navigateCode.UPDATE:
                    if (await this.validate(sendModel)) {
                        res = await this.updateThuchiNgansach({ model: sendModel })
                    }
                    break
                case this.navigateCode.DELETE_TEMP:
                    res = await this.deleteThuchiNgansach({ model: sendModel, type: this.sType_List })
                    break
                case this.navigateCode.DELETE:
                    res = await this.deleteThuchiNgansach({ model: sendModel, type: this.sType_List })
                    break
                case this.navigateCode.RESTORE:
                    res = await this.restoreThuchiNgansach({ model: sendModel })
                    break
                default:
            }
            if (res) {
                await this.getData()
                this.hideModal()
            }
        },
        async checkExistName(name) {
            let params = {
                ten: name
            }
            let res = await this.checkExistThuchiNgansach({ params: params })
            return res.data

        },


        async confirmList(code) {
            if (this.csList_Navigate.csList.length == 0) {
                this.warning(this.$t('labels.selectItem'))
            }
            else {
                this.csList_Navigate.csList_Code = code
                let foundItem = this.navigateList.find(item => item.code === code);
                this.csList_Navigate.csList_Title = foundItem ? foundItem.title : ""

                this.csList_MapModel = {
                    title: this.csList_Navigate.csList_Title,
                    confirmLabelButton: this.csList_Navigate.csList_Title,
                    onClose: this.hidePopupconfirmcsListModal,
                    onSubmit: this.onSubmitList,
                    modalContent: "Bạn có chắc chắn <b>" + this.csList_Navigate.csList_Title + "</b> các dữ liệu đã chọn?",
                }
                this.showPopupconfirmcsListModal()
            }

        },

        async onSubmitList() {
            let code = this.csList_Navigate.csList_Code
            let modelSend = {
                model: {
                    listId: this.csList_Navigate.csList.toString()
                },
                type: code
            }
            console.log(code)
            if (code == this.navigateCode.OFF_ENABLED) {
                modelSend.model.enabled = false
            }
            if (code == this.navigateCode.ON_ENABLED) {
                modelSend.model.enabled = true
            }
            let res = null
            res = await this.handleListThuchiNgansach(modelSend)
            if (res) {
                await this.getData()
                await this.navigateCheckBoxAll()
                this.hidePopupconfirmcsListModal()
            }
        },


        async getCategory_Ky(filterNumber = 0) {
            let params = {
                tableName: tableValue.TCKH_THUCHINGANSACH,
                loaiKy: 'Y'
            }
            params.filter = filterNumber
            let res = await this.getBasicDMKy({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].idKy,
                            name: res[i].tenKy
                        }
                    )
                }
                return handleRes
            }

            return res
        },

        async getCategory_ChiTieuThuChiNganSach() {
            let params = {
            }
            let res = await this.getBasicChitieuThuchiNgansach({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].chitieuThuchiNgansachId,
                            name: res[i].ten
                        }
                    )
                }

                return handleRes
            }
            return []
        },

    },

    async mounted() {
        await this.initialize()
        await this.setup()
        await this.getData()
    }
}
</script>
<style></style>